module.exports = __webpack_public_path__ + "img/5-2.1daba3c4.svg";